<template>
  <div class="selection-days">
    <h4 class="selection-days__label">{{label || 'Укажите рабочие дни'}}</h4>
    <div class="selection-days__list">
      <button v-for="(day, index) in days"
              :key="day"
              @click.prevent="onClick(index)"
              :class="computedValue[index] ? '_active' : null"
              class="selection-days__btn  selection-days">
        {{$tGlobal(day)}}
      </button>
    </div>
  </div>
</template>

<script>
  const days = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa']

  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      },
      label: String
    },
    data() {
      return {
        localesWithFirstDayOne: ['ua', 'ru']
      }
    },
    computed: {
      computedValue() {
        const d = [...this.value]
        let a = d.splice(0, this.firstDayOfWeek)
        return d.concat(a)
      },
      days() {
        const d = [...days]
        let a = d.splice(0, this.firstDayOfWeek)
        return d.concat(a)
      },
      firstDayOfWeek() {
        return this.localesWithFirstDayOne.includes(this.$store.state.currentLocale) ? 1 : 0
      },
    },
    methods: {
      onClick(index) {
        let newValue = [...this.computedValue]
        newValue[index] = !newValue[index]

        let a = newValue.splice(-this.firstDayOfWeek, this.firstDayOfWeek)
        newValue = a.concat(newValue)

        this.$emit('input', newValue)
      }
    }
  }
</script>

<style lang="less">

</style>
